function NoSitesListedYet() {
  return (
    <div className="pb-8">
      <div className="flex flex-col container mx-auto ">
        <h1>Sites</h1>
        <div className="flex justify-center items-center pt-12">
          <div className="flex flex-col items-center">
            <h2 className="font-medium text-xl text-gray-900 pb-2">
              No sites listed yet
            </h2>
            <p className="pb-6 w-96 text-center font-normal text-base text-gray-500">
              Lorem ipsum dolor sit amet consectetur. Viverra pharetra purus
              diam vulputate maecenas eget.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoSitesListedYet
